import React from "react";
import {
  GitBookBtn,
  HeaderTitle,
  ImgWrapper,
  MainSection,
  MainWrapper,
  MobileTextDiv,
  ResponsiveRoadmapWrapper,
  Text,
  TextDiv,
  Title,
} from "./elements";
import { LightButton, MainCol, MainContainer } from "components/common";
import { Image } from "react-bootstrap";
import {
  mobileroadmap,
  mobileroadmap2,
  newroadmap,
  roadmap,
  newresponsiveroadmap,
  roadmap1,
} from "assets";
import { data } from "./data";
import { SiGitbook } from "react-icons/si";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { FaCheckCircle } from "react-icons/fa";
import { BsCheck } from "react-icons/bs";
const RoadMapComp = () => {
  const handleButtonClick = () => {
    window.open("https://www.gitbook.com", "_blank");
  };

  const TextComp = ({ text }) => {
    const lines = text.split("\n").map((line, index) => (
      <Text key={index}>
        {line.trim()} <BsCheck className="ml-2" color="#00FF06" fontSize={16} />
      </Text>
    ));

    return <>{lines}</>;
  };

  return (
    <MainSection id="roadmap">
      <MainContainer>
        <AnimationOnScroll animateIn="animate__bounceIn">
          <Title>Our Roadmap</Title>
        </AnimationOnScroll>

        <AnimationOnScroll animateIn="animate__fadeInUp">
          <MainWrapper>
            <MainCol lg={12}>
              <Image src={roadmap1} height={434} fluid />
            </MainCol>

            {data.map((item, index) => (
              <TextDiv
                className={
                  (index == 0 && "first-div") ||
                  (index == 1 && "second-div") ||
                  (index == 2 && "third-div") ||
                  (index == 3 && "fourth-div") ||
                  (index == 4 && "fifth-div")
                }
              >
                {index === 1 || index === 3 ? (
                  <>
                    {/* <Text>{item.text}</Text> */}
                    <TextComp text={item.text} />
                    <HeaderTitle>{item.title}</HeaderTitle>
                  </>
                ) : (
                  <>
                    <HeaderTitle>{item.title}</HeaderTitle>
                    <TextComp text={item.text} />
                    {/* <Text>{item.text}</Text> */}
                  </>
                )}
              </TextDiv>
            ))}
          </MainWrapper>
        </AnimationOnScroll>
        <ResponsiveRoadmapWrapper>
          <ImgWrapper>
            <Image src={newresponsiveroadmap} />
          </ImgWrapper>

          {data.map((item, index) => (
            <MobileTextDiv
              className={
                (index == 0 && "first-div") ||
                (index == 1 && "second-div") ||
                (index == 2 && "third-div") ||
                (index == 3 && "fourth-div") ||
                (index == 4 && "fifth-div")
              }
            >
              <>
                <HeaderTitle>{item.title}</HeaderTitle>
                <TextComp text={item.text} />
                {/* <Text>{item.text}</Text> */}
              </>
            </MobileTextDiv>
          ))}
        </ResponsiveRoadmapWrapper>

        <div className="btn-div">
          <LightButton btnText="Gitbook" bookIcon={true} navigate="gitbook" />
        </div>
      </MainContainer>
    </MainSection>
  );
};

export default RoadMapComp;
